module.exports = __webpack_public_path__ + "img/ysgr-xr.6383d446.png";